import { AppSession } from "@/api";
import { AppSessionsTableType } from "../types/appSession.type";
import { columns } from "./AppSessionsColumns";
import { AppSessionsTable } from "./AppSessionsTable";

interface Props {
  appSessions: AppSession[];
  loading: boolean;
}

export function AppSessionsView({ appSessions, loading }: Props) {
  const appSessionsData: AppSessionsTableType[] = appSessions.map(
    ({
      node: {
        __typename,
        id,
        userId,
        userEmail,
        accessType,
        app,
        startTime,
        endTime,
        ownerOrganization
      }
    }) => ({
      __typename,
      id,
      userId,
      userEmail: userEmail ?? "",
      accessType,
      appName: app.displayName,
      startTime,
      endTime,
      ownerOrganization
    })
  );

  return (
    <AppSessionsTable
      data={appSessionsData}
      columns={columns}
      loading={loading}
    />
  );
}
